export const DEAL_TYPES = [
  {
    value: 1,
    title: "فروش",
  },
  {
    value: 2,
    title: "رهن و اجاره",
  },
  {
    value: 3,
    title: "تهاتر (معاوضه)",
  },
  {
    value: 4,
    title: "پیش فروش",
  },
  {
    value: 5,
    title: "مشارکت در ساخت",
  },
];

export const MAIN_SUB_CATEGORY = [
  {
    value: "1",
    title: "اداری،تجاری",
  },
  {
    value: "2",
    title: "مسکونی",
  },
  {
    value: "3",
    title: "ویلایی و زمین",
  },
  {
    value: "4",
    title: "زیر قیمت",
  },
];

export const PLACE_TYPES = [
  {
    value: 1,
    title: "آپارتمان اداری",
  },
  {
    value: 2,
    title: "تجاری-اداری",
  },
  {
    value: 3,
    title: "آپارتمان مسکونی",
  },
  {
    value: 4,
    title: "ویلایی",
  },
  {
    value: 5,
    title: "کلنگی",
  },
  {
    value: 6,
    title: "زمین",
  },
];
export const DOCUMENT_TYPES = [
  {
    value: 1,
    title: "شخصی",
  },
  {
    value: 2,
    title: "استان قدس",
  },
  {
    value: 3,
    title: "بنیاد",
  },
  {
    value: 4,
    title: "اوقاف",
  },
];

export const ATTR_OPTIONS = [
  {
    id: 0,
    title: "انباری",
  },
  {
    id: 1,
    title: "تراس",
  },
  {
    id: 2,
    title: "سرایداری",
  },
  {
    id: 3,
    title: "سونا",
  },
  {
    id: 4,
    title: "استخر",
  },
  {
    id: 5,
    title: "سالن ورزشی",
  },
  {
    id: 6,
    title: "سالن سرگرمی",
  },
  {
    id: 7,
    title: "آسانسور",
  },
  {
    id: 8,
    title: "لابی",
  },
  {
    id: 9,
    title: "کفپوش",
  },
  {
    id: 10,
    title: "جکوزی",
  },
  {
    id: 11,
    title: "هلی پد",
  },
  {
    id: 12,
    title: "سالن اجتماعات",
  },
  {
    id: 13,
    title: "کتابخانه",
  },
];
